// extracted by mini-css-extract-plugin
export default {"waitingroom":"waiting-room_waitingroom__wESKg","container":"waiting-room_container__JA18S"};